$(document).ready(function(){
  $('.currency-button').click(function(e){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    $.fancybox.open($('.modal-currency'));
  });
  
  InitCustomSelect();
  setTimeout(InitCustomSelect, 1000);
  setTimeout(InitCustomSelect, 2000);
  
  function InitCustomSelect() {
    if ($('.usf-dropdown:not(.custom-select)').length > 0) {
      var indexCustomSelect = $('.usf-dropdown option:selected').index();
      $('.usf-dropdown:not(.custom-select)').customSelect();
      if (indexCustomSelect > 0) {
        $('.usf-dropdown').parent().find('.custom-select-list li').removeClass('active');
        $('.usf-dropdown').parent().find('.custom-select-list li:eq('+indexCustomSelect+')').addClass('active');
        $('.usf-dropdown').parent().find('.custom-select-selected').text($('.usf-dropdown').parent().find('.custom-select-list li.active').text());
      }
    }
  }

  // INQUIRE
  $('a.open-form-inquire').click(function(e){
    e.preventDefault();
    $('body').addClass('form-inquire-open');
  });
  $('#form-inquire a.close, #form-inquire .bg').click(function(e){
    e.preventDefault();
    $('body').removeClass('form-inquire-open');
  });

  // QUANTITY
  $('.product-plus.js-change-quantity').click(function(e){
    var target = $(this).parent().find('input');
    if (target.val() >= Number(target.attr('max'))) {
      $('.quantity-err').remove();
      //target.closest('.purchase-details').prepend('<div class="quantity-err">Quantity max : ' + target.attr('max') + '</div>');
    }
  });
  $('.product-minus.js-change-quantity').click(function(e){
    $('.quantity-err').remove();
  });
});

// CUSTOM SELECT
$.fn.customSelect = function() {
  var select = this;
  var selectContainerWidth = 0;
  var selectOffsetWidth = 50;

  this.addClass('custom-select');

  var initSelects = function() {
    $('.custom-select').each(function(e) {
      var selectOptions = [];
      var selectHtml = '';
      var selectIndex = e;
      var selectOptionPlaceholder = $(this).attr('data-select-placeholder') || '';
      var selectOptionTheme = $(this).attr('data-select-theme') || '';
      var selectWidth = $(this).attr('data-select-width') || '';
      var selectOptionWidth = $(this).attr('data-select-dropdown-width') || '';

      $(this).find('option').each(function() {
        var option = $(this);
        var optionText = option.text();
        var optionValue = option.val();

        selectOptions.push({
          'text': optionText,
          'value': optionValue
        });
      });

      $(this).wrap('<div class="custom-select-container" data-select-id="' + selectIndex + '" data-select-theme="' + selectOptionTheme + '" data-select-width="' + selectWidth + '" data-select-dropdown-width="' + selectOptionWidth + '" data-select-state="closed">');

      selectHtml += '<div class="custom-select-selected">' + (selectOptionPlaceholder != '' ? selectOptionPlaceholder : selectOptions[0].text) + '</div>';
      selectHtml += '<ul class="custom-select-list">';

      $.each(selectOptions, function(index, value) {
        selectHtml += '<li data-select-option-value="' + selectOptions[index].value + '"'+ (index == 0 ? ' class="active"' : '') +'>' + selectOptions[index].text + '</li>';
      });

      selectHtml += '</ul>';

      $(this).after(selectHtml);

      if (selectOptionWidth == 'auto') {
        var selectOptionHtml = '';

        $.each(selectOptions, function(index, value) {
          selectOptionHtml += selectOptions[index].text + '<br>';
        });

        var dummyWidthElement = $('<div class="custom-select-dropdown-sizer">').html(selectOptionHtml).css({
          'font-size': $(this).css('font-size'),
          'visibility': 'hidden'
        });

        dummyWidthElement.appendTo($(this).parent());

        var width = dummyWidthElement.outerWidth();

        dummyWidthElement.remove();

        $(this).closest('.custom-select-container').find('> .custom-select-list').width(width + selectOffsetWidth);
      }

      $(this).hide();
    });
  }

  $(document).on('click', '.custom-select-container > .custom-select-selected', function(e) {
    var dropdownsOpen = $('.custom-select-list:visible').length;

    if (dropdownsOpen > 0) {
      hideDropdowns();
    }

    $(this).find('+ .custom-select-list').show();
    $(this).closest('.custom-select-container').attr('data-select-state', 'open');
  });

  $(document).on('click', function(e) {
    if ( !$(e.target).is('.custom-select-selected, .custom-select-list') ) {
      hideDropdowns();
    }
  });

  $(document).on('click', '.custom-select-list li', function(e) {
    var clicked = $(e.target);
    var selectedText = clicked.text();
    var selectedValue = clicked.attr('data-select-option-value');
    var clickedSelectIndex = clicked.closest('.custom-select-container').attr('data-select-id');
    var selectContainer = $('.custom-select-container[data-select-id=' + clickedSelectIndex + ']');

    selectContainer.find('li.active').removeClass('active');
    $(e.target).addClass('active');
    
    selectContainer.find('select').prop('selectedIndex', selectContainer.find('li.active').index());
    selectContainer.find('select').val(selectedValue).change();
    
    window.history.pushState('', '', window.location.pathname + '?usf_sort=' + selectedValue);
    
    selectContainer.find('.custom-select-selected').text(selectedText);
  });

  /*$(document).on('change', '.custom-select-container select', function(e) {
    var optionText = $(this).find(':selected').text();
    var optionValue = $(this).val();
    
    $(this).closest('.custom-select-container').find('.custom-select-selected').text(optionText);
    
    //Shopify.queryParams.sort_by = optionValue;
    //location.search = new URLSearchParams(Shopify.queryParams).toString();
    //quickFilter.init();
  });*/

  var hideDropdowns = function() {
    $('.custom-select-container > .custom-select-list').hide();
    $('.custom-select-container').attr('data-select-state', 'closed');
  }

  initSelects();    
};
